import {jQuery as $, lodash as _} from 'lib/shim';

import {Context} from 'context';
import {waitForRepaint} from '../../../javascript/util/dom';



const NAME = 'organism-filtered-location-list',
	SELECTOR = '.'+NAME;



class OrganismFilteredLocationList {

	constructor(app, $element){
		if( !$.isSet($element.dataDuo('primed')) ){
			$element.dataDuo('primed', true);

			this._app = app;
			this._id = $.randomUuid(true);
			this._$element = $element;

			this._$filterbox = this._$element.find('.filterbox').first();
			this._$locationHolder = this._$element.find('.filtered-locations').first();
			this._$googleMapMolecule = this._$element.find('.molecule-google-map').first();
			this._dataUrl = this._$googleMapMolecule.dataDuo('url');
			this._$map = this._$googleMapMolecule.find('.map-wrapper > .map').first();

			this._locationsInitialCount = $.isSet(this._$element.data('locations-initial-count'))
				? this._$element.data('locations-initial-count')
				: 12
			;
			this.ucMapProviderDisabled = window.uc.disabledProviders.SCRIPT ? window.uc.disabledProviders.SCRIPT.find(function (item) {
				return item.pid.includes('S1pcEj_jZX');
			}) : false;

			this._locationTemplate = this._$element.find('.location-template').html();
			this._infoLayerTemplate = this._$element.find('.infolayer-template').html();
			this._locationsUrl = this._$element.data('locations-url');
			$.assert($.isSet(this._locationsUrl, 'OrganismFilteredLocationList.constructor | no locations url has been provided'));
			this._locationsJson = null;
			this._fittingLocations = null;
			this._currentFilterTags = {};

			this._prime();
		}

		return $element;
	}



	_prime(){
		if (!this.ucMapProviderDisabled) {
			$.getJSON(this._locationsUrl, (locationsJson) => {
				$.assert($.isArray(locationsJson), 'OrganismFilteredLocationList._prime | locations json must be an array of objects');
				this._locationsJson = locationsJson;
				this._fittingLocations = this._locationsJson;
				this._refreshFilterTags(this._locationsJson);
				this._updateFilterbox(false, true);
				this._$element.removeClass('loading');
			}).done(() => {
				$.when(this._app.loadDynamicDependency('GoogleMapsApi', this._dataUrl)).done(() => {
					this._$filterbox.trigger('submit.app');
				});
			});
		} else {
			this._$element.removeClass('loading');
		}


		this._$filterbox.on('filterschanged.app', (e, data) => {
			let filters = data.filters;

			this._fittingLocations = _.filter(this._locationsJson, function(location){
				let res = true;

				_.each(filters, (filterValue, filterName) => {
					if(
						!$.isSet(location.filterAttributes)
						|| !$.isSet(location.filterAttributes[filterName])
						|| (!$.isSet(location.filterAttributes[filterName].value) && !$.isArray(location.filterAttributes[filterName].values))
						|| ((filterValue !== location.filterAttributes[filterName].value) && !_.includes(location.filterAttributes[filterName].values, filterValue))
					){
						res = false;
						return false;
					}
				});

				return res;
			});

			this._updateFilterbox(true, false);
		});


		this._$filterbox.on('submitted.app', () => {
			this._$locationHolder.empty();
			this._showLocations();

			this._$element.addClass('filtered');

			this._refreshFilterTags(this._fittingLocations);
			this._updateFilterbox();
		});
	}



	_refreshFilterTags(locations){
		this._currentFilterTags = {};

		let currentFilterTagsMap = {};

		_.each(locations, (location) => {
			_.each(location.filterAttributes, (filterTag, filterName) => {
				if( !$.isSet(currentFilterTagsMap[filterName]) ){
					currentFilterTagsMap[filterName] = {
						values : [],
						textMap : {}
					};
				}

				if( $.isSet(filterTag.value, filterTag.text) ){
					currentFilterTagsMap[filterName].values.push(filterTag.value);
					currentFilterTagsMap[filterName].textMap[filterTag.value] = filterTag.text;
				}

				if( $.isArray(filterTag.values) && $.isArray(filterTag.texts) ){
					_.each(filterTag.values, (value, index) => {
						currentFilterTagsMap[filterName].values.push(value);
						currentFilterTagsMap[filterName].textMap[value] = filterTag.texts[index];
					});
				}
			});
		});

		_.each(currentFilterTagsMap, (map, filterName) => {
			_.each(_.uniq(map.values), (value) => {
				if( !$.isSet(this._currentFilterTags[filterName]) ){
					this._currentFilterTags[filterName] = [];
				}

				this._currentFilterTags[filterName].push({
					value : value,
					text : map.textMap[value]
				});
			});

			this._currentFilterTags[filterName] = _.sortBy(this._currentFilterTags[filterName], ['text']);
		});
	}



	_updateFilterbox(onlyCount, init){
		if( init ){
			this._$filterbox.triggerHandler('updatefilterdata.app', {
				mode : 'from-scratch',
				filters : this._currentFilterTags
			});
		} else if( onlyCount ){
			this._$filterbox.triggerHandler('updatefilterdata.app', {
				count : _.size(this._fittingLocations)
			});
		} else {
			this._$filterbox.triggerHandler('updatefilterdata.app', {
				count : _.size(this._fittingLocations),
				keepSubmitState : true,
				mode : 'from-scratch',
				filters : this._currentFilterTags
			});
		}
	}



	_showLocations(){
		this._$googleMapMolecule.triggerHandler('clear-markers');

		_.each(this._fittingLocations, (location, index) => {
			let $newLocation = $($.strFormat(this._locationTemplate, {
				image_alt : location.image.alt,
				image_desktop : location.image.sources.desktop,
				image_tablet : location.image.sources.tablet,
				image_mobile : location.image.sources.mobile,
				image_default : location.image.sources.default,
				headline : location.headline,
				copytext : location.copytext
			}));

			if( $.isEmpty(location.copytext) ){
				$newLocation.find('.copytext').remove();
			}

			$newLocation.addClass('preparing');
			this._$locationHolder.append($newLocation);
			waitForRepaint(() => {
				$newLocation.removeClass('preparing');
			});

			let $newLocationMarker = $($.strFormat(this._infoLayerTemplate, {
				company_name : location.place.companyName,
				street_address : location.place.streetAddress,
				zip_code : location.place.zipCode,
				city : location.place.city,
				phone : location.place.telephone,
				phone_url : 'tel:'+$.strReplace(' ', '', location.place.telephone),
				fax : location.place.fax,
				fax_url : 'tel:'+$.strReplace(' ', '', location.place.fax),
				email : location.place.email,
				email_url : 'mailto:'+$.strReplace(' ', '', location.place.email),
				web_address : location.place.webAddress,
				web_address_url : location.place.webAddress,
				target : true,
			}));

			// let markerAddress = location.place.companyName + ' ' + location.place.streetAddress + ' ' + location.place.zipCode + ' ' + location.place.city;
			let markerLatLng = {lat: parseFloat(location.place.position.lat), lng: parseFloat(location.place.position.lng)};
			$newLocationMarker.addClass('preparing');
			this._$googleMapMolecule.triggerHandler('add-marker', {location : markerLatLng, html: $newLocationMarker.get(0).outerHTML});
			waitForRepaint(() => {
				$newLocationMarker.removeClass('preparing');
			});
		});

		this._$googleMapMolecule.triggerHandler('fit-bounds');
	}
}



export function init(app){
	let $elements = $();

	$(SELECTOR).each(function(){
		let $this = $(this);

		$elements = $elements.add(new OrganismFilteredLocationList(app, $this));
	});

	return $elements;
}
